module.exports = __webpack_public_path__ + "media/images/flags/4x3/pan-3f4707c94a8841f66a47fa4403992fa5.svg";